// Structured API error. Mirrors backend ApiError shape:
//   {detail: string, code: string, resource?: string, field?: string}
// plus the X-Request-Id correlation header.
//
// IMPORTANT: ApiError represents a NON-2xx response. The tenant
// dual-write 201-with-X-Vault-Sync:error path is a SUCCESS with
// degraded metadata; that surfaces as `vaultSyncFailed: true` on the
// request<T> success return, NOT as an ApiError. Mixing them was a
// reviewer-caught bug in an earlier plan draft.

export interface ApiErrorJson {
  detail?: string;
  code?: string;
  resource?: string | null;
  field?: string | null;
}

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly resource: string | null;
  readonly field: string | null;
  readonly requestId: string | null;
  readonly raw: unknown;

  constructor(args: {
    status: number;
    detail: string;
    code: string;
    resource?: string | null;
    field?: string | null;
    requestId?: string | null;
    raw?: unknown;
  }) {
    super(args.detail);
    this.name = "ApiError";
    this.status = args.status;
    this.code = args.code;
    this.resource = args.resource ?? null;
    this.field = args.field ?? null;
    this.requestId = args.requestId ?? null;
    this.raw = args.raw;
  }
}
